import gql from "graphql-tag";

const queryCreateDepartment = gql`
  mutation(
    $name: String!
    $status: String
    $canShowOnDocument: Boolean
    $parentId: ID
    $managerIds: [ID!]
    $workShiftIds: [ID!]
    $createHelperIds: [ID!]
    $hrReporterIds: [ID!]
  ) {
    createDepartment(
      data: {
        name: $name
        status: $status
        parentId: $parentId
        managerIds: $managerIds
        workShiftIds: $workShiftIds
        createHelperIds: $createHelperIds
        hrReporterIds: $hrReporterIds
        canShowOnDocument: $canShowOnDocument
      }
    ) {
      id
      name
      status
      updatedAt
      createdAt
    }
  }
`;

const queryUpdateDepartment = gql`
  mutation(
    $name: String
    $status: String
    $canShowOnDocument: Boolean
    $id: ID!
    $parentId: ID
    $managerIds: [ID!]
    $workShiftIds: [ID!]
    $createHelperIds: [ID!]
    $hrReporterIds: [ID!]
    $supervisorIds: [ID!]
  ) {
    updateDepartment(
      id: $id
      data: {
        name: $name
        status: $status
        parentId: $parentId
        managerIds: $managerIds
        workShiftIds: $workShiftIds
        createHelperIds: $createHelperIds
        hrReporterIds: $hrReporterIds
        supervisorIds: $supervisorIds
        canShowOnDocument: $canShowOnDocument
      }
    ) {
      id
      name
      status
      updatedAt
      createdAt
    }
  }
`;

const queryDeleteDepartment = gql`
  mutation($id: ID!) {
    deleteDepartment(id: $id) {
      id
    }
  }
`;

export default {
  queryCreateDepartment,
  queryUpdateDepartment,
  queryDeleteDepartment,
};
